import { baseEnv } from './base';

export const prodEnv: { baseUrl: { notification: string } } = {
  baseUrl: {
    notification: `https://api.notification.${baseEnv.domain.prod}`,
  },
};
